var FacetId = /* @__PURE__ */ ((FacetId2) => {
  FacetId2["productType"] = "productType";
  FacetId2["price"] = "price";
  FacetId2["brand"] = "brand";
  FacetId2["lensColor"] = "lensColor";
  FacetId2["frameColor"] = "frameColor";
  FacetId2["categoryExternalId"] = "categoryExternalId";
  FacetId2["isOfferedWithPrescriptions"] = "isOfferedWithPrescriptions";
  return FacetId2;
})(FacetId || {});
const PrimaryFacets = {
  [
    "productType"
    /* productType */
  ]: true,
  [
    "price"
    /* price */
  ]: true,
  [
    "brand"
    /* brand */
  ]: true
};
function isFacetHidden(facet) {
  return facet.hidden === true;
}
function isFacetVisible(facet) {
  return !isFacetHidden(facet);
}
function isValidAlgoliaSearchConfig(obj) {
  return Object.values(obj).every(Boolean);
}
export {
  FacetId,
  PrimaryFacets,
  isFacetHidden,
  isFacetVisible,
  isValidAlgoliaSearchConfig
};
//# sourceMappingURL=types.js.map
